import React from 'react';
import { ILinkedIntegration } from '../PublishCourseView';
import { useTheme } from '@mui/material/styles';
import { NiasLogoIcon, WPLogoIcon } from '../../../../../features/integrations/ActiveIntegrations';
import Typography from '@mui/material/Typography/Typography';
import IconButton from '@mui/material/IconButton/IconButton';
import PublishIcon from '@mui/icons-material/Publish';
import DeleteIcon from '@mui/icons-material/Delete';
import SettingsIcon from '@mui/icons-material/Settings';
import CircularProgress from '@mui/material/CircularProgress/CircularProgress';
import Tooltip from '@mui/material/Tooltip/Tooltip';

interface ILinkedIntegrationProps {
  integration: ILinkedIntegration;
  publishingStates: {
    [key: number]: boolean;
  };
  handlePublishToIntegration: () => void;
  handleRemoveIntegration: () => void;
  handleOpenIntegrationSettings: () => void;
}

export default function LinkedIntegrations({ integration, publishingStates, handlePublishToIntegration, handleRemoveIntegration, handleOpenIntegrationSettings }: ILinkedIntegrationProps) {
  const theme = useTheme();

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: theme.spacing(1),
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: theme.spacing(0.5),
          marginBottom: theme.spacing(1),
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ height: 34, width: 34 }}>
            {integration.lmsTypeId === 1 && <WPLogoIcon />}
            {integration.lmsTypeId === 2 && <NiasLogoIcon />}
          </div>
          <div>
            <Typography variant='body2' style={{ fontWeight: 500 }}>
              {integration.url}
            </Typography>
            <Tooltip title={integration.courseLMSLink?.lmsCourseName} arrow>
              <Typography
                variant='caption'
                color='textSecondary'
                noWrap
                style={{ display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis', wordBreak: 'break-word', maxWidth: 220 }}
              >
                {integration.courseLMSLink ? `Target Course: ${integration.courseLMSLink.lmsCourseName}` : 'Integration'}
              </Typography>
            </Tooltip>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}>
          <IconButton size='small' color='primary' onClick={() => handlePublishToIntegration()} disabled={publishingStates[integration.customerId]}>
            {publishingStates[integration.customerId] ? <CircularProgress size={16} color='inherit' /> : <PublishIcon />}
          </IconButton>
          {integration.lmsTypeId === 2 && (
            <IconButton size='small' onClick={() => handleOpenIntegrationSettings()} disabled={publishingStates[integration.customerId]}>
              <SettingsIcon />
            </IconButton>
          )}
          <IconButton size='small' onClick={() => handleRemoveIntegration()} title='Remove integration'>
            <DeleteIcon />
          </IconButton>
        </div>
      </div>
    </>
  );
}
